import React, { useEffect, useState } from "react";
import { PaperPlaneTilt } from "@phosphor-icons/react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function EmailQuoteDialog({ open, onClose, quote, customer, onSent }) {
  const [to, setTo] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);

  useEffect(() => {
    if (open) {
      setTo(customer?.email || "");
      setSubject(`Your roofing quote — ${quote?.quote_number || ""}`);
      setMessage(`Hi ${(customer?.name || "").split(" ")[0] || "there"},\n\nPlease find your roofing quote attached. Happy to walk you through it on the phone or arrange a site visit.\n\nMany thanks.`);
    }
  }, [open, customer, quote]);

  if (!open) return null;

  const send = async (e) => {
    e.preventDefault();
    if (!quote?.id) { toast.error("Save the quote first"); return; }
    setSending(true);
    try {
      const { data } = await api.post(`/quotes/${quote.id}/email`, { to, subject, message });
      if (data.mocked) toast.success(`Email queued (MOCKED) — set RESEND_API_KEY to deliver`);
      else toast.success(`Email sent to ${to}`);
      onSent?.(data);
      onClose();
    } catch (e2) {
      toast.error(formatApiError(e2.response?.data?.detail) || "Failed to send");
    } finally { setSending(false); }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/60 z-50 grid place-items-center p-4" onClick={onClose}>
      <form onClick={(e) => e.stopPropagation()} onSubmit={send} className="card-sharp w-full max-w-lg p-6" data-testid="email-quote-dialog">
        <div className="overline">Send quote</div>
        <h3 className="font-display text-2xl font-bold mt-1">Email PDF to customer</h3>
        <p className="text-xs text-slate-500 mt-1">Quote <span className="font-mono-data font-semibold">{quote?.quote_number || "—"}</span> will be attached as a PDF.</p>

        <label className="block mt-5">
          <span className="overline">To</span>
          <input data-testid="email-to-input" type="email" required className="rqp mt-1.5" value={to} onChange={(e) => setTo(e.target.value)} />
        </label>
        <label className="block mt-4">
          <span className="overline">Subject</span>
          <input data-testid="email-subject-input" required className="rqp mt-1.5" value={subject} onChange={(e) => setSubject(e.target.value)} />
        </label>
        <label className="block mt-4">
          <span className="overline">Message</span>
          <textarea data-testid="email-message-input" rows={6} className="rqp mt-1.5" value={message} onChange={(e) => setMessage(e.target.value)} />
        </label>

        <div className="flex justify-end gap-2 mt-6">
          <button type="button" className="btn-secondary" onClick={onClose}>Cancel</button>
          <button type="submit" className="btn-primary flex items-center gap-2" disabled={sending} data-testid="email-send-button">
            <PaperPlaneTilt size={14} weight="bold" /> {sending ? "Sending…" : "Send PDF"}
          </button>
        </div>
      </form>
    </div>
  );
}
